import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isAuthPath } from "../CrmUi/authCrm";
import { useCrm } from "../CrmUi/useCrm";
import { loadSupportChat, removeSupportChat } from "../../services/supportChat";

/**
 * Everything's chat on every dashboard page, in the CRM's colour (HubSpot's
 * orange or Outreach's violet), reloaded when the CRM changes. The sign-in
 * pages are always light, so the chat is too; elsewhere it follows the
 * app's theme. Not on embedded surfaces (the Outreach extension frames),
 * where a bubble over a prospect's conversations is only in the way.
 */
const SupportChat: FC<{ hidden?: boolean }> = ({ hidden = false }) => {
  const { pathname } = useLocation();
  const crm = useCrm();
  const auth = isAuthPath(pathname);

  useEffect(() => {
    if (hidden) return;
    loadSupportChat({ crm, appearance: auth ? "light" : undefined });
    return removeSupportChat;
  }, [crm, auth, hidden]);

  return null;
};

export default SupportChat;
